import { useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL || '';
const supabaseKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || '';

let supabase: any = null;

try {
  if (supabaseUrl && supabaseKey) {
    supabase = createClient(supabaseUrl, supabaseKey);
  }
} catch (err) {
  console.error('Failed to initialize Supabase:', err);
}

interface NotificationSystemProps {
  isAuthenticated: boolean;
}

export const NotificationSystem = ({ isAuthenticated }: NotificationSystemProps) => {
  const [hasPermission, setHasPermission] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !('Notification' in window)) return;

    // Check current permission
    if (Notification.permission === 'granted') {
      setHasPermission(true);
    } else if (Notification.permission === 'default') {
      // Request permission
      Notification.requestPermission().then(permission => {
        setHasPermission(permission === 'granted');
      });
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated || !hasPermission || !supabase) return;

    // Subscribe to new order notifications
    const channel = supabase
      .channel('order_notifications')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'order_notifications'
        },
        async (payload: any) => {
          console.log('New notification received:', payload);

          // Fetch order details
          const { data: orderData } = await supabase
            .from('orders')
            .select('*')
            .eq('order_id', payload.new.order_id)
            .single();

          if (orderData && Notification.permission === 'granted') {
            const notification = new Notification('🎉 New Order Received!', {
              body: `Order ${orderData.order_id} - $${orderData.total_amount.toFixed(2)}\\nYou earned $${orderData.commission_amount.toFixed(2)}!`,
              icon: '/favicon.ico',
              tag: orderData.order_id,
              requireInteraction: true,
              badge: '/favicon.ico'
            });

            notification.onclick = () => {
              window.focus();
              window.location.href = '/dashboard';
              notification.close();
            };
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [isAuthenticated, hasPermission]);

  return null; // This is a background component
};

export default NotificationSystem;
